import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import dayjs from 'dayjs';

export interface DTicketPriceConfig {
	oldPrice: number;
	newPrice: number;
	priceChangeDate: string;
	messageVisibleFrom: string;
	messageVisibleUntil: string;
}

export interface DTicketPriceContextValue extends DTicketPriceConfig {
	dayBeforePriceChangeDate: string;
}

const DTicketPriceContext = createContext<DTicketPriceContextValue | undefined>(
	undefined
);

export const DTicketPriceProvider: FC<{
	config: DTicketPriceConfig;
	children: ReactNode;
}> = ({ config, children }) => {
	const contextValue = useMemo(
		() => ({
			...config,
			dayBeforePriceChangeDate: dayjs(config.priceChangeDate)
				.subtract(1, 'day')
				.format('YYYY-MM-DD'),
		}),
		[config]
	);

	return (
		<DTicketPriceContext.Provider value={contextValue}>
			{children}
		</DTicketPriceContext.Provider>
	);
};

export const useDTicketPriceConfig = () => {
	const context = useContext(DTicketPriceContext);

	if (!context) {
		throw new Error(
			'useDTicketPriceConfig must be used within a DTicketPriceProvider. ' +
				'Wrap your component tree with <DTicketPriceProvider config={environment.deutschlandTicket}>.'
		);
	}

	return context;
};
